import { render, staticRenderFns } from "./CommercialInfo.vue?vue&type=template&id=7ecd34bd&scoped=true&lang=pug&"
import script from "./CommercialInfo.vue?vue&type=script&lang=js&"
export * from "./CommercialInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommercialInfo.vue?vue&type=style&index=0&id=7ecd34bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd34bd",
  null
  
)

component.options.__file = "CommercialInfo.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
  VLayout,
})
